(function ($) {
  "use strict";

  Drupal.behaviors.popup = {
    attach: function (context, settings) {
      $(function() {

        $('.js-popup', context).click(function() {
          var $popup = $(this).closest('.js-popup'),
              activeClass = 'popup--active';

          $popup
            .addClass(activeClass)
            .find('input:eq(0)').select().focus();

          $('body').one('click', function() {
            $popup.removeClass(activeClass);
          });

          $popup.find('.popup__icon').one('click', function() {
            $popup.removeClass(activeClass);
            return false;
          });

          return false;
        });
      });
    }
  };

})(jQuery);
